/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.badgesModule')
.controller('AccountAddBadgeModalController', ['$modalInstance','BulbAuthService','BulbBusyService','BulbErrorService','BulbModalService','Restangular','$scope','$state', AccountAddBadgeModalController]);

function AccountAddBadgeModalController($modalInstance, BulbAuthService, BulbBusyService, BulbErrorService, BulbModalService, Restangular,
                    $scope, $state) {

  var that = this;
  $modalInstance.result.then(function() {
    // Activates the badges service and sets the current groups equal to the variable groups for instant display.
    BulbBusyService.showBusyDuring(Restangular.one('accounts', BulbAuthService.currentUser.id).one('badges').post()
      .then(function(badges) {
        if (badges) {
          $state.reload();
        } else {
          that.showBadgeMissingModal();
        }
      }).catch(function(e) {
        BulbErrorService.error('Cannot update the user badges', e);
      }).finally(function() {
        $scope.$dismiss('cancel');
      }));
  });

  // Modal options for the badges not found modal
  var notFoundModalOptions = {
    okButtonCode: 'button_ok',
    bodyCode: 'badge_modal_not_found_text',
    windowClass: 'bulb-badgenotfound-modal',
    showTitle: false,
    showCancelButton: false
  };

  // Shows the modal on click
  this.showBadgeMissingModal = function() {
    BulbModalService.show(notFoundModalOptions);
  };

  this.cancel = function() {
    $scope.$dismiss('cancel');
  };
}

